module.exports = __webpack_public_path__ + "img/voxuy.dde5eb09.svg";